import { useAtomValue, useSetAtom } from 'jotai';
import { atomWithSessionStorage } from './atomWithSessionStorage';
import type { FeatureFlag } from './featureFlags';
import { defaultFeatureFlags } from './featureFlags';

export type FeatureFlagState = {
  flags: Record<FeatureFlag, boolean>;
  overrides: Record<FeatureFlag, boolean>;
};

export const featureFlagAtom = atomWithSessionStorage('featureFlags', {
  flags: defaultFeatureFlags,
  overrides: Object.fromEntries(
    Object.keys(defaultFeatureFlags).map((key) => [key, false])
  ) as Record<FeatureFlag, boolean>,
} satisfies FeatureFlagState);

/** Not intended for direct use in the app, use useFeatureFlags instead */
export const useFeatureFlagAtomValues = () => useAtomValue(featureFlagAtom);

/** Only intended for use in the devtool and should not be used directly in the app */
export const useFeatureFlagAtomSetter = () => useSetAtom(featureFlagAtom);
